const Message = (path) => (rowData) =>
  rowData[path]
    ? rowData[path].length > 50
      ? `${rowData[path].substring(0, 50)}...`
      : rowData[path]
    : ''
export default Message
